// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import 'lib-flexible'
import './utils/flexible.js'
// import Vconsole from 'vconsole';
// // process.env.NODE_ENV === 'development' && 
// new Vconsole()
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      // localStorage.setItem('isiphone',flag)
      localStorage.setItem('ismobile', flag ? 1 : 0);
      let goUrl = flag ? 1 : 0;
      return goUrl;
    },
  },
  created() {
    let goUrl = this.isMobile();
     // 实例创建完成后被立即调用rem换算方法,解决内容闪现问题

    if (goUrl === 1) {
      setRem();
      window.addEventListener('resize', setRem);//浏览器窗口大小改变时调用rem换算方法
      //移动端地址
      this.$router.replace('/wap')
      // location = 'https://www.retouchspace.com/mobile.html';
    } else {
      // 初始化菜单
      // util.initRouter(this);
      // 显示打开的页面的列表
      // this.$store.commit('setOpenedList');
      // this.$store.commit('initCachepage');
    }
  },


  mounted () {
    document.dispatchEvent(new Event('render-event'))
  },
})
//rem换算 
function setRem() {
  var whdef = 100 / 750; // 表示1920的设计图,使用100PX的默认值
  var bodyWidth = document.body.clientWidth; // 当前窗口的宽度
  var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
  document.getElementsByTagName('html')[0].style.fontSize = rem + 'px';
}


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js